import { auth_id, auth_secret } from '../../config/App'
import { Http } from '../../config/Http'
import { changeLoading } from './loading.action'
import { changeNotify } from './notify.action'
import { change as changeVerifySms } from './sms.action'

export const actionTypes = {
    CHANGE: 'AUTH_CHANGE',
    NEXT: 'AUTH_NEXT',
    SUCCESS: 'AUTH_SUCCESS',
    ERROR: 'AUTH_ERROR'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const setError = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

export const setNext = (payload) => ({
    type: actionTypes.NEXT,
    payload
})

export const setUserToken = token => dispatch => {
    localStorage.setItem('access_token', token);
    dispatch( change({
        email: '',
        password: ''
    }))

    window.location.replace('/')
}

export const login = credentials => dispatch => {
    dispatch(changeLoading({
        open: true,
        msg: 'Autenticando usuário...'
    }))
    
    return Http.post('oauth/token', {
        grant_type: 'password',
        client_id: auth_id,
        client_secret: auth_secret,
        username: credentials.email,
        password: credentials.password
    })
    .then(res => {
        dispatch( changeLoading({ open: false }) );

        if(res.data.access_token) {
            dispatch( setUserToken(res.data.access_token) );
        }
    })
    .catch(error => {
        dispatch( changeLoading({ open: false }) );

        if(typeof error.response !== 'undefined') {
            if(error.response.status === 401 || error.response.status === 400) {
                if(typeof error.response.data === 'object'){
                    if(typeof error.response.data.error_code !== undefined) {
                        if(error.response.data.error_code) {
                            dispatch(changeVerifySms({
                                open: true,
                                screen_id: 'auth'
                            }))
                        }
                    }
                    
                    if(typeof error.response.data.error !== undefined) {
                        
                        if(error.response.data.error === 'invalid_request') {
                            dispatch( changeNotify({
                                open: true,
                                class: 'error',
                                msg: 'Informe seu email e senha'
                            }))
                        }

                        if(error.response.data.error === 'invalid_grant') {
                            dispatch( changeNotify({
                                open: true,
                                class: 'error',
                                msg: 'E-mail ou Senha incorretos'
                            }))
                        }
                    }
                }
            }
        } else {
            dispatch( changeNotify({
                open: true,
                class: 'error',
                msg: 'Erro ao se conectar ao servidor'
            }) )
        }
        
    })
}

/* VALIDATE CODE */

export const validateCode = async (credentials) => {
    return await Http.post('/v2/verification-code', credentials)
    .then(res => res.data && res.data)
    .catch(error => {
        if(error.response) {
            if(error.response.status === 400) {
                return error.response.data
            } 
        }
    })
}